import "./LoadingIndicator.scss";

export const LoadingIndicator = () => (
  <div className="loading-indicator">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
);
